import { APPOINTMENT_CHANNEL, APPOINTMENT_STATUS } from "../enums/appointment";
import { QUEUE_CARD_ACTIONS } from "../enums/workflow-view";

export const VIEW_APT_STATUS = [
  {
    value: APPOINTMENT_STATUS.CANCELLED,
    display_text: "Cancelled",
  },
  {
    value: APPOINTMENT_STATUS.ABORTED,
    display_text: "Aborted",
  },
  {
    value: APPOINTMENT_STATUS.ONGOING,
    display_text: "Ongoing",
  },

  {
    value: APPOINTMENT_STATUS.COMPLETED,
    display_text: "Completed",
  },
  {
    value: APPOINTMENT_STATUS.RESCHEDULED,
    display_text: "Rescheduled",
  },
  {
    value: APPOINTMENT_STATUS.BOOKED,
    display_text: "Booked",
  },
  {
    value: APPOINTMENT_STATUS.CHECKED_IN,
    display_text: "Checked in",
  },
  {
    value: APPOINTMENT_STATUS.NO_SHOW,
    display_text: "No Show",
  },
  {
    value: APPOINTMENT_STATUS.INITIATED,
    display_text: "Followup or Patient Requested",
  },
  {
    value: APPOINTMENT_STATUS.PARKED,
    display_text: "Parked",
  },
];

//TODO: What do to for initiated cases?

export const VIEW_APT_STATUS_MAP: Record<string, string> = {
  [APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION]: APPOINTMENT_STATUS.COMPLETED,
  [APPOINTMENT_STATUS.DOCTOR_CANCELLED]: APPOINTMENT_STATUS.CANCELLED,
  [APPOINTMENT_STATUS.STAFF_CANCELLED]: APPOINTMENT_STATUS.CANCELLED,
  [APPOINTMENT_STATUS.NO_SHOW_DOCTOR]: APPOINTMENT_STATUS.NO_SHOW,
  [APPOINTMENT_STATUS.NO_SHOW_STAFF]: APPOINTMENT_STATUS.NO_SHOW,
  [APPOINTMENT_STATUS.DOCTOR_RESCHEDULED]: APPOINTMENT_STATUS.RESCHEDULED,
  [APPOINTMENT_STATUS.STAFF_RESCHEDULED]: APPOINTMENT_STATUS.RESCHEDULED,
};

export const VIEW_APT_CHANNEL = [
  {
    value: APPOINTMENT_CHANNEL.WALKIN,
    display_text: "Walk in",
  },
  {
    value: APPOINTMENT_CHANNEL.FOLLOW_UP,
    display_text: "Follow up",
  },
  {
    value: APPOINTMENT_CHANNEL.PATIENT_REQUESTED,
    display_text: "Patient Requested",
  },
  {
    value: APPOINTMENT_CHANNEL.OFFLINE,
    display_text: "Offline",
  },
  {
    value: APPOINTMENT_CHANNEL.STAFF,
    display_text: "Staff",
  },
  {
    value: APPOINTMENT_CHANNEL.DOCTOR,
    display_text: "Doctor",
  },
  {
    value: APPOINTMENT_CHANNEL.ONLINE_APPOINTMENT,
    display_text: "Online Appointment",
  },
  {
    value: APPOINTMENT_CHANNEL.ABHA,
    display_text: "ABHA",
  },
];

export const VIEW_PAYMENT_CHANNEL = [
  {
    value: "paid",
    display_text: "Billed",
  },
  {
    value: "unbilled",
    display_text: "Unbilled",
  },
];

export const VIEW_SELF_ASSESSMENTS_CHANNEL = [
  {
    value: "true",
    display_text: "Assessment Filled (At least one)",
  },
  {
    value: "false",
    display_text: "No Assessment Filled",
  },
];

export const DEFAULT_ACTION_CONFIG: Array<
  Array<{
    colId: QUEUE_CARD_ACTIONS;
    colType?: string;
    isFixed?: boolean;
  }>
> = [
  [
    {
      colId: QUEUE_CARD_ACTIONS.TAGS,
    },
    {
      colId: QUEUE_CARD_ACTIONS.VISIT_TYPE,
    },
  ],
  [
    {
      colId: QUEUE_CARD_ACTIONS.RECEIPT,
    },
    {
      colId: QUEUE_CARD_ACTIONS.CREATE_ABHA,
    },
    {
      colId: QUEUE_CARD_ACTIONS.ADD_VITALS_AND_LAB_RESULTS,
    },
    {
      colId: QUEUE_CARD_ACTIONS.UPLOAD_MEDICAL_RECORDS,
    },
  ],
];
